var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarSelect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1065 11H9.06845V16H14.1065V11ZM13.0989 0V2H5.03803V0L3.02282 0V2H2.01521C0.896769 2 0.010076 2.9 0.010076 4L0 18C0 19.1 0.896769 20 2.01521 20H16.1217C17.2301 20 18.1369 19.1 18.1369 18V4C18.1369 2.9 17.2301 2 16.1217 2H15.1141V0L13.0989 0ZM16.1217 18H2.01521V7H16.1217V18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarSelect);
export default __webpack_public_path__ + "static/media/CalendarSelect.98f9f1295a048393d6ecdaf7ec88eff3.svg";
export { ForwardRef as ReactComponent };